module.exports = __webpack_public_path__ + "assets/img/AuditCover-w540.a50d907d.jpg";